import React from 'react';
import { HiMenuAlt3 } from 'react-icons/hi';
import { IoArrowBack } from 'react-icons/io5';

export default function NavigationBarMobileChrome({
  activeMenuId,
  activeProject,
  hasUnreadOpsChat,
  onOpenMenu,
}) {
  return (
    <>
      {activeMenuId && (
        <div
          role="button"
          tabIndex={0}
          aria-label="Back to menu"
          className="mobile-nav-top-safe"
          style={{
            position: 'fixed',
            left: '20px',
            zIndex: 9998,
            backgroundColor: 'var(--archon-navy-deep)',
            width: '50px',
            height: '50px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            border: '1px solid rgba(255,255,255,0.2)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
          }}
          onClick={onOpenMenu}
          onKeyDown={(e) => e.key === 'Enter' && onOpenMenu()}
        >
          <IoArrowBack style={{ color: 'var(--archon-white)', fontSize: '24px' }} />
        </div>
      )}
      <div
        data-tour="mobile-nav-toggle"
        className="mobile-nav-top-safe"
        style={{
          position: 'fixed',
          left: activeMenuId ? '80px' : '20px',
          zIndex: 9998,
          backgroundColor: 'var(--archon-navy-deep)',
          width: '50px',
          height: '50px',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          border: '1px solid rgba(255,255,255,0.2)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        }}
        onClick={onOpenMenu}
      >
        <HiMenuAlt3 style={{ color: 'var(--archon-white)', fontSize: '28px' }} />
        {hasUnreadOpsChat && (
          <span
            className="ops-chat-unread-dot"
            aria-label="Unread operations chat messages"
            title="Unread Operations Chat messages"
            style={{ position: 'absolute', top: '6px', right: '6px' }}
          />
        )}
      </div>

      {activeProject && (
        <div
          data-tour="mobile-project-pill"
          className="mobile-nav-top-safe"
          style={{
            position: 'fixed',
            left: activeMenuId ? '140px' : '80px',
            zIndex: 9998,
            backgroundColor: 'rgba(43,88,179,0.15)',
            height: '50px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '0 12px',
            cursor: 'pointer',
            border: '1px solid rgba(43,88,179,0.5)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            maxWidth: `calc(100vw - ${activeMenuId ? '160px' : '100px'})`,
            overflow: 'hidden',
          }}
          onClick={onOpenMenu}
        >
          <i className="bi bi-folder-check" style={{ color: 'var(--archon-nav-active-text)', fontSize: '0.9rem', flexShrink: 0 }} />
          <span style={{
            color: 'var(--archon-accent)',
            fontSize: '0.75rem',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontFamily: '"Century Gothic", sans-serif',
          }}
          >
            {activeProject.project_name}
          </span>
          {hasUnreadOpsChat && (
            <span
              className="ops-chat-unread-dot"
              aria-label="Unread operations chat messages"
              title="Unread Operations Chat messages"
              style={{ marginLeft: '4px', flexShrink: 0 }}
            />
          )}
        </div>
      )}
    </>
  );
}
